module.exports = __webpack_public_path__ + "site/img/289.1793a551.jpg";